export const isPortalSurface =
  typeof window !== 'undefined' &&
  (window.location.pathname === '/t' || window.location.pathname.startsWith('/t/'))
